import { Box } from '@mui/material';
import * as React from 'react';
import { BrandLogo } from '../../common/brandLogo/BrandLogo';
import { useAuth } from '../../../hooks/useAuth';

export const FullScreenErrorPage = ({ children }: { children: React.ReactNode }) => {
    const { isAuthenticated, logout } = useAuth();

    return (
        <Box height="100dvh" display="grid" gridTemplateRows={'auto 1fr'} lineHeight={1.5} fontWeight="normal" fontSize={16}>
            {isAuthenticated && (
                <Box textAlign={'right'}>
                    <button
                        style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer', color: '#284b76' }}
                        onClick={() => {
                            logout();
                        }}
                    >
                        Logout
                    </button>
                </Box>
            )}
            <Box display={'flex'} flexDirection="column" alignItems="center" justifyContent="center" textAlign="center">
                <BrandLogo variant="row" style={{ width: '12em', height: 'auto', marginBottom: 24 }} />
                {children}
            </Box>
        </Box>
    );
};
